/* eslint-disable import/prefer-default-export */

export const FILTERS = 'filters';
